export const FETCH_ECTS_LOADING = 'FETCH_ECTS_LOADING';
export const FETCH_ECTS_SUCCESS = 'FETCH_ECTS_SUCCESS';
export const FETCH_ECTS_ERROR = 'FETCH_ECTS_ERROR';

export const FETCH_ECT_LOADING = 'FETCH_ECT_LOADING';
export const FETCH_ECT_SUCCESS = 'FETCH_ECT_SUCCESS';
export const FETCH_ECT_ERROR = 'FETCH_ECT_ERROR';

export const CREATE_ECT_LOADING = 'CREATE_ECT_LOADING';
export const CREATE_ECT_SUCCESS = 'CREATE_ECT_SUCCESS';
export const CREATE_ECT_ERROR = 'CREATE_ECT_ERROR';

export const UPDATE_ECT_LOADING = 'UPDATE_ECT_LOADING';
export const UPDATE_ECT_SUCCESS = 'UPDATE_ECT_SUCCESS';
export const UPDATE_ECT_ERROR = 'UPDATE_ECT_ERROR';

export const DELETE_ECT_LOADING = 'DELETE_ECT_LOADING';
export const DELETE_ECT_SUCCESS = 'DELETE_ECT_SUCCESS';
export const DELETE_ECT_ERROR = 'DELETE_ECT_ERROR';

export const ACTIVATE_INVALID_BOT_DIALOGUE = 'ACTIVATE_INVALID_BOT_DIALOGUE';
export const DEACTIVATE_INVALID_BOT_DIALOGUE =
  'DEACTIVATE_INVALID_BOT_DIALOGUE';

export const ACTIVATE_CONTACT_SALES_TEAM_DIALOGUE =
  'ACTIVATE_CONTACT_SALES_TEAM_DIALOGUE';
export const DEACTIVATE_CONTACT_SALES_TEAM_DIALOGUE =
  'DEACTIVATE_CONTACT_SALES_TEAM_DIALOGUE';
